// 树结构
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@mui/material';
import { isUndefined } from 'lodash';

import { Loading } from '../../components';
import './zTree.css'

const ZTreeFolderItem: React.FC = (props: any) => {
  const {item, hidden, curCatalog, setCurCatalog, displayNodes, breadcrumbs} = props;
  const history = useHistory();

  // hidden 当前节点是否隐藏
  // isHidden 下一层级节点是否隐藏
  const [isHidden, setIsHidden] = useState(true);

  // 判断当前操作节点的子节点是否在显示节点中，如果在，直接展开和收起，如果不在，就重新请求数据
  const childrenExistAtDisplayNodes = () => {
    var isExist = false;
    if (item && item.children.length > 0 && displayNodes && displayNodes.length > 0) {
      for (let i = 0; i < item.children.length; i++) {
        if (displayNodes.indexOf(item.children[i].id) !== -1) {
          isExist = true;
          break;
        }
      }
    }
    return isExist;
  };

  const handleClickItem = () => {
    setIsHidden(!isHidden)
    if (!childrenExistAtDisplayNodes()) {
      history.push('/products/'+item.id);
    }
  };

  const handleClickArrow = () => {
    if (curCatalog.id === item.id) {
      setIsHidden(!isHidden);
    } else {
      handleClickItem();
    }
  };


  useEffect(() => {
    setIsHidden(true);
    if (isUndefined(hidden)) {
      if (item && breadcrumbs && breadcrumbs.length > 0) {
        for (let i = 0; i < breadcrumbs.length; i++) {
          if (item.id === breadcrumbs[i].id) {
            setIsHidden(false);
            break;
          }
        }
      }
      return;
    }
    if (hidden === false) return;
    setIsHidden(hidden); // 如果当前节点是隐藏的，那么下级节点也是隐藏的
  }, [hidden, item, breadcrumbs]);

  return (
    <Box style={{paddingLeft:'20px'}}>
      <Box style={{
        width:'100%', padding:'15px 15px 15px 0px', cursor:'pointer',
        border:'solid #bebebe', borderWidth:'0px 0px 1px 0px', 
        display: (isUndefined(hidden) || !hidden ) ? 'flex' : 'none', 
        flexDirection:'row', 
        alignItems:'center'
      }}>
        <Box style={{
          paddingLeft:'20rpx', flexGrow:1, whiteSpace:'nowrap', textOverflow:'ellipsis', 
          overflow:'hidden', fontSize:'16px', color: curCatalog?.id === item?.id ? 'red' : 'unset'
        }} onClick={handleClickItem}>
          {item.cgName?.zh}
        </Box>
        <img
          src={ (isHidden) ? '/images/right.svg' : '/images/down.svg' }
          style={{ width:'20px', height:'20px' }}
          onClick={handleClickArrow}
        />
      </Box>

      {displayNodes && displayNodes.length > 0 && item.children && item.children.map(((item1, i) => {
        if (displayNodes.indexOf(item1.id) !== -1) {
          if (item1.type === 'folder') {
            return (<ZTreeFolderItem key={i} hidden={isHidden} curCatalog={curCatalog} setCurCatalog={setCurCatalog} displayNodes={displayNodes} item={item1} />)
          } else {
            return (<ZTreeFileItem key={i} hidden={isHidden} displayNodes={displayNodes} item={item1} />)
          }
        }
      }))}

      {(!displayNodes || displayNodes.length <= 0) && item.children && item.children.map(((item1, i) => {
        if (item1.type === 'folder') {
          return (<ZTreeFolderItem key={i} hidden={isHidden} curCatalog={curCatalog} setCurCatalog={setCurCatalog} item={item1} />)
        } else {
          return (<ZTreeFileItem key={i} hidden={isHidden} item={item1} />)
        }
      }))}
    </Box>
  );
};

const ZTreeFileItem: React.FC = (props: any) => {
  const {item, hidden} = props;
  const history = useHistory();

  const handleClickItem = () => {
    history.push('/productDetail/'+item.id);
  }

  return (
    <Box style={{paddingLeft:'30px'}}>
      <Box style={{
        cursor:'pointer',
        border:'solid #bebebe', 
        borderWidth: '0px 0px 1px 0px', 
        padding:' 15px 15px 15px 0px', 
        display:(!hidden) ? 'flex' : 'none',
        flexDirection:'row', 
        width:'100%', 
        alignItems:'center'
      }}>
        <Box style={{
          fontSize:'16px', paddingLeft:'20rpx', flexGrow:1, whiteSpace:'nowrap', 
          textOverflow:'ellipsis', overflow:'hidden'
        }} onClick={handleClickItem}>
          {item.details?.descriptionShort?.zh}
        </Box>
      </Box>
    </Box>
  );
};

const MZTree: React.FC = (props: any) => {
  const { children } = props;
  return (
    <Box>{children}</Box>
  );
};

const ZTree: React.FC = (props: any) => {
  const { data, curCatalog, setCurCatalog, displayNodes, breadcrumbs } = props;
    
  return (
    <Box className='ztree'> 
      <MZTree >
        {data.map((item, i) => {
          if (item.type === 'folder') {
            return (
              <ZTreeFolderItem 
                key={i} 
                item={item} 
                curCatalog={curCatalog} 
                setCurCatalog={setCurCatalog} 
                displayNodes={displayNodes}
                breadcrumbs={breadcrumbs}
              />
            )
          } else {
            return (
              <ZTreeFileItem 
                key={i} 
                item={item} 
                curCatalog={curCatalog} 
                setCurCatalog={setCurCatalog} 
                displayNodes={displayNodes} 
                breadcrumbs={breadcrumbs}
              />
            )
          }
        })}  
      </MZTree>
    </Box>
  );
};

export default ZTree;